import styled from "styled-components";

export const FlatpicFooterWrapper = styled.div`
  text-align: center;
  font-size: 0.6rem;
`;